import React, { useEffect, useRef, useState } from "react";
import {
  OTP_LENGTH,
  RESEND_OTP_DELAY_IN_SECONDS,
  RESEND_OTP_LIMITS,
} from "../../../constents/numbers";
import useRegistOtpVerify from "../../../Hooks/Registration/useRegistOtpVerify";
import useRegistOtpSender from "../../../Hooks/Registration/useRegistOtpSender";
import { ButtonWithoutIcon } from "../../../constents/components";
import { useNavigate } from "react-router-dom";
import { AuthStepsParagraph } from "../../../constents/components";

// const OtpComponent = ({ details, sendToNextStep }) => {
//     const { email, password } = details;
//     const [resendOtpLoading, resendOtpError, isSucess, otpSendingFunction] = useRegistOtpSender();
//     const [otpVerifyLoading, otpVerifyError, isOtpVerified, otpVerifier] = useRegistOtpVerify(sendToNextStep);
//     const Navigate = useNavigate();

//     const [errors, setErrors] = useState({ otp: '' });

//     // const [otp, setOtp] = useState(new Array(6).fill(''));
//     const [otp, setOtp] = useState(0);

//     // { isOtpVerified && sendToNextStep() }

//     const [secondsLeft, setSecondsLeft] = useState(RESEND_OTP_DELAY_IN_SECONDS);
//     const [isResendButtonEnable, setIsResendButtonEnable] = useState(false);

//     const intervalId = useRef();
//     const secondsTimerCreater = () => {

//         intervalId.current = setInterval(() => {

//             setSecondsLeft(pre => {
//                 if (pre === 0) {
//                     setIsResendButtonEnable(true);
//                     clearInterval(intervalId.current);
//                     return pre;
//                 }
//                 else {
//                     return pre - 1;
//                 }
//             });

//         }, 1000);
//     }
//     useEffect(() => secondsTimerCreater(), []);

//     const onSubmit = () => {
//         // otpVerifier({ email, password, otp: otp?.map(item => parseInt(item)).reduce((accumulator, currentvalue) => { return (accumulator * 10) + currentvalue }) });
//         otpVerifier({ email, password, otp });
//     }

//     const otpResender = () => otpSendingFunction(details.email);
//     return (
//         <>
//             <div className='mt-4 w-full'>

//                 <input
//                     type="number"
//                     className=' appearance-none w-full border-b-2 p-1 outline-none'
//                     min={0}
//                     max={999999}
//                     placeholder='Enter OTP'
//                     value={otp || ''}
//                     onChange={(e) => setOtp(parseInt(e.target.value))}
//                 />
//                 {errors?.otp && (<p className='text-sm mt-2 font-semibold text-[#ff0000]'>{errors?.otp}</p>)}

//                 {/* <
//                     length={6}
//                     state={otp}
//                     setState={setOtp}
//                     /> */}
//             </div>

//             {otpVerifyError && (<p className='text-sm mt-2 font-semibold text-[#ff0000]'>{otpVerifyError}</p>)}

//             {/* <div className=' flex justify-between'>
//                 {secondsLeft > 0 && (<p>{secondsLeft}</p>)}
//                 {isResendButtonEnable &&
//                 (<span
//                 className={` text-sm ${isResendButtonEnable ? ' text-primary_800 hover:cursor-pointer' : ' text-primary_500 hover:cursor-not-allowed'}  hover:text-primary_500 `}
//                 onClick={() => isResendButtonEnable && otpResender()}
//                 >
//                 Resend OTP
//                 </span>
//                 )
//                 }
//                 </div> */}

//             <ButtonWithoutIcon
//                 text={otpVerifyLoading ? "Loading..." : "Continue"}
//                 onButtonClick={() => onSubmit()}
//                 classNames={` mt-8 w-full ${otpVerifyLoading ? ' cursor-not-allowed' : 'cursor-pointer'} text-white p-4  ${otp.length < OTP_LENGTH ? ' bg-gray-500 hover:cursor-not-allowed' : ' bg-[#FF5D10] hover:cursor-pointer'}`}
//             />

//             <div className=' mt-2'>
//                 <p className=' text-gray-400'>Already have an account ? <span className='text-primary-color-900  font-semibold cursor-pointer' onClick={() => Navigate('/auth/login')}>Log in </span> </p>
//                 {/* <p className='pt-1 text-gray-400 text-xs'>By continuing, you agree to Termns of Use and Privacy Policy  </p> */}
//             </div>
//         </>
//     )
// }

// export default OtpComponent;

import { InputBoxWraper } from "../../../constents/components";
import { useDispatch } from "react-redux";
import { updateCurrentRegistrationStep } from "../../../Store/Slices/registrationStates";

const MobileNumberVerification = ({ details, sendToNextStep }) => {
  const intervalId = useRef();

  const [loading, error, otpSender] = useRegistOtpSender(() => {});
  const [isOtpSendSucess, setIsOtpSendSucess] = useState(true);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const OTP_TIMER_DURATION = 180;

  const [resendOtpTimer, setResendOtpTimer] = useState(() => {
    const expiryTime = sessionStorage.getItem("registration_otp_expiry");

    if (!expiryTime) {
      return OTP_TIMER_DURATION;
    }

    const remainingSeconds = Math.ceil(
      (Number(expiryTime) - Date.now()) / 1000,
    );

    return Math.max(0, remainingSeconds);
  });

  const [numbersOfResendOtpAttempts, setNumberOfResenOtpAttempts] = useState(
    () => {
      const attempts = sessionStorage.getItem(
        "registration_otp_resend_attempts",
      );

      return attempts ? Number(attempts) : 0;
    },
  );
  const [otpVerifyLoading, otpVerifyError, isOtpVerified, otpVerifier] =
    useRegistOtpVerify(sendToNextStep);

  const { email, password } = details;
  const Navigate = useNavigate();

  const sendOtpFunction = async () => {
    const res = await otpSender(email);

    const newAttempts = numbersOfResendOtpAttempts + 1;

    setNumberOfResenOtpAttempts(newAttempts);
    setIsOtpSendSucess(true);

    sessionStorage.setItem(
      "registration_otp_resend_attempts",
      String(newAttempts),
    );

    const expiryTime = Date.now() + OTP_TIMER_DURATION * 1000;

    sessionStorage.setItem("registration_otp_expiry", String(expiryTime));

    setResendOtpTimer(OTP_TIMER_DURATION);
  };
  const verifyOtpFunction = async () => {
    if (!otp) {
      setOtpError("Please enter the OTP");
      return;
    }

    if (otp.length !== OTP_LENGTH) {
      setOtpError(`Please enter a valid ${OTP_LENGTH}-digit OTP`);
      return;
    }

    setOtpError("");

    await otpVerifier({
      email,
      password,
      otp,
    });
  };

  useEffect(() => {
    const updateTimer = () => {
      const expiryTime = sessionStorage.getItem("registration_otp_expiry");

      if (!expiryTime) {
        return;
      }

      const remainingSeconds = Math.ceil(
        (Number(expiryTime) - Date.now()) / 1000,
      );

      if (remainingSeconds <= 0) {
        setResendOtpTimer(0);
        clearInterval(intervalId.current);
        return;
      }

      setResendOtpTimer(remainingSeconds);
    };

    updateTimer();

    intervalId.current = setInterval(updateTimer, 1000);

    return () => {
      clearInterval(intervalId.current);
    };
  }, []);

  useEffect(() => {
    const existingExpiry = sessionStorage.getItem("registration_otp_expiry");

    if (!existingExpiry) {
      const expiryTime = Date.now() + OTP_TIMER_DURATION * 1000;

      sessionStorage.setItem("registration_otp_expiry", String(expiryTime));

      setResendOtpTimer(OTP_TIMER_DURATION);
    }
  }, []);

  useEffect(() => {
    if (resendOtpTimer <= 1) {
      setResendOtpTimer(0);
      clearInterval(intervalId.current);
    }
  }, [resendOtpTimer]);

  return (
    <div className=" min-w-40">
      <div className="mt-4 w-full">
        <input
          type="number"
          name=""
          placeholder="Enter OTP"
          id=""
          className=" appearance-none w-full border-b-2 p-1 outline-none"
          min={0}
          max={999999}
          value={otp || ""}
          onWheel={(e) => {
            e.target.blur();
          }}
          onChange={(e) => {
            const value = e.target.value
              .replace(/\D/g, "")
              .slice(0, OTP_LENGTH);
            setOtp(value);
            setOtpError("");
          }}
        />

        {otpError && (
          <p className="text-sm mt-2 font-semibold text-[#ff0000]">
            {otpError}
          </p>
        )}

        {otpVerifyError && (
          <p className="text-sm mt-2 font-semibold text-[#ff0000]">
            {otpVerifyError}
          </p>
        )}

        {error && (
          <p className="text-sm mt-2 font-semibold text-[#ff0000]">{error}</p>
        )}

      </div>
      <div className=" w-full flex justify-end gap-2">
        {loading ? (
          <p className=" text-sm text-primary-color-900">Sending OTP...</p>
        ) : (
          numbersOfResendOtpAttempts >= 0 && (
            <>
              {resendOtpTimer > 1 && (
                <p className=" text-sm text-primary-color-900">
                  {"0" + Math.trunc(resendOtpTimer / 60)}:
                  {Math.trunc(resendOtpTimer % 60) < 10
                    ? "0" + Math.trunc(resendOtpTimer % 60)
                    : Math.trunc(resendOtpTimer % 60)}
                </p>
              )}
              <p
                onClick={() => resendOtpTimer < 1 && sendOtpFunction()}
                className={`text-sm  ${resendOtpTimer > 1 ? " cursor-not-allowed text-primary-color-100" : " cursor-pointer text-primary-color-900 hover:underline"}`}
              >
                Resend OTP
              </p>
            </>
          )
        )}
      </div>

      <ButtonWithoutIcon
        text={otpVerifyLoading ? "Loading..." : "Continue"}
        onButtonClick={() => verifyOtpFunction()}
        classNames={` mt-8 w-full ${otpVerifyLoading ? " cursor-not-allowed" : "cursor-pointer"} text-white p-4  ${otp.length < OTP_LENGTH ? " bg-gray-500 hover:cursor-not-allowed" : " bg-[#FF5D10] hover:cursor-pointer"}`}
      />

      <div className=" mt-2">
        <p className=" text-gray-400">
          Already have an account ?{" "}
          <span
            className="text-primary-color-900  font-semibold cursor-pointer"
            onClick={() => Navigate("/auth/login")}
          >
            Log in{" "}
          </span>{" "}
        </p>
        {/* <p className='pt-1 text-gray-400 text-xs'>By continuing, you agree to Termns of Use and Privacy Policy  </p> */}
      </div>
      <br />
      <AuthStepsParagraph text="Please check your inbox and enter the code below to continue." />
    </div>
  );
};
export default MobileNumberVerification;
